import { motion } from "framer-motion";

export default function PartnerRow({ partner, index }) {
  return (
    <motion.li
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay: index * 0.03 }}
      data-testid={`partner-${partner.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="py-5 border-t border-background/15"
    >
      <div className="flex items-baseline gap-3">
        <span
          className="font-mono text-xs tracking-[0.18em]"
          style={{ color: "hsl(220 18% 72%)" }}
        >
          {String(index + 1).padStart(2, "0")}
        </span>
        <h3
          className="font-display text-lg md:text-xl font-semibold tracking-tight leading-tight"
          style={{ color: "hsl(38 38% 95%)" }}
        >
          {partner.name}
        </h3>
      </div>
      <div
        className="mt-1 font-mono text-[0.6rem] uppercase tracking-[0.22em]"
        style={{ color: "hsl(220 18% 72%)" }}
      >
        {partner.role}
      </div>
      <p className="mt-2 text-sm text-background/70 leading-relaxed max-w-md">
        {partner.lines[0]}
      </p>
    </motion.li>
  );
}
